import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type TriageCategory =
  | "action_required"
  | "awaiting_reply"
  | "fyi"
  | "noise"
  | "linked_to_project";

const CATEGORY_LABELS: Record<TriageCategory, string> = {
  action_required: "Action requise",
  awaiting_reply: "En attente",
  fyi: "Pour info",
  noise: "Bruit",
  linked_to_project: "Projet",
};

const CATEGORY_SHORT_LABELS: Record<TriageCategory, string> = {
  action_required: "Action",
  awaiting_reply: "Attente",
  fyi: "Info",
  noise: "Bruit",
  linked_to_project: "Projet",
};

const CATEGORY_STYLES: Record<TriageCategory, string> = {
  action_required:
    "bg-rose-100 text-rose-800 border-rose-200 dark:bg-rose-950/40 dark:text-rose-200 dark:border-rose-900",
  awaiting_reply:
    "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-900",
  fyi:
    "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950/40 dark:text-sky-200 dark:border-sky-900",
  noise:
    "bg-muted text-muted-foreground border-border",
  linked_to_project:
    "bg-violet-100 text-violet-800 border-violet-200 dark:bg-violet-950/40 dark:text-violet-200 dark:border-violet-900",
};

export const TRIAGE_CATEGORIES: TriageCategory[] = [
  "action_required",
  "awaiting_reply",
  "fyi",
  "noise",
  "linked_to_project",
];

export function triageLabel(c: TriageCategory): string {
  return CATEGORY_LABELS[c];
}

export function TriageBadge({
  category,
  short = false,
  className,
}: {
  category: TriageCategory | string | null | undefined;
  short?: boolean;
  className?: string;
}) {
  if (!category) return null;
  const c = category as TriageCategory;
  const styles = CATEGORY_STYLES[c];
  if (!styles) return null;
  return (
    <Badge
      variant="outline"
      className={cn("text-[10px] uppercase tracking-wide font-semibold", styles, className)}
    >
      {short ? CATEGORY_SHORT_LABELS[c] : CATEGORY_LABELS[c]}
    </Badge>
  );
}
